import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';
import CarouselContentComponent from './CarouselContentSection';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    paritialVisibilityGutter: 0,
    padding: 20,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    paritialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};
const Reviews = [
  {
    title: 'Manager, ElectroWorld, Indore',
    name: 'Shalini Tiwari',
    profitPercentage: '35%',
    reviewText:
      'Falcon has strenthened our working capital and ensured timely payements, which ultimately helps to bring better assortment to retailers. ',
  },
  {
    title: 'Owner of Lakshmi Electronics, Bangalore',
    name: 'Pavan Kumar',
    profitPercentage: '35%',
    reviewText:
      'Highly recommend using falcon to scale up bussiness. It helped me in growing my bussiness and achieving 10X growth in past one year.',
  },

  {
    title: 'Owner of Naveen Telecom, Assam',
    name: 'Pulkit Tiwari',
    profitPercentage: '20%',
    reviewText:
      'Due to falcon my annual revenue increased by 2X. Stocks and prices are updated as per current market using Catalogue management tool. ',
  },
];
const CustomLeftArrow = ({ onClick }) => (
  <i onClick={() => onClick()} className="custom-left-arrow" />
);
const CustomRightArrow = ({ onClick }) => {
  return <Button>Click</Button>;
};

const CustomButtonGroup = ({ next, previous, goToSlide, carouselState }) => {
  const { totalItems, currentSlide } = carouselState;
  return (
    <div className={`custom-button-group ${styles.customButton}`}>
      <div>Current slide is {currentSlide}</div>
      <button onClick={() => previous()}>Previous slide</button>
      <button onClick={() => next()}>Next slide</button>
      <button onClick={() => goToSlide(Math.floor(Math.random() * totalItems + 1))}>
        Go to a random slide
      </button>
    </div>
  );
};
const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
  const {
    carouselState: { currentSlide },
  } = rest;
  return (
    <div className={`custom-button-group ${styles.customButton}`}>
      <Button
        className={`${currentSlide === 0 ? 'disable' : ''} ${styles.custBtn}`}
        onClick={() => previous()}
      >
        <div className={styles.iconContainer}>
          <img
            alt="arzooo-header-logo"
            className={styles.headerLogo}
            src="/images/prevArrow.svg"
          ></img>
        </div>
      </Button>
      <Button className={styles.custBtn} onClick={() => next()}>
        <div className={styles.iconContainer}>
          <img
            alt="arzooo-header-logo"
            className={styles.headerLogo}
            src="/images/nextArrow.svg"
          ></img>
        </div>
      </Button>
    </div>
  );
};
const CarouselComponent = () => {
  return (
    <div>
      <Carousel
        ssr={true}
        partialVisbile
        itemClass="image-item"
        responsive={responsive}
        infinite={true}
        arrows={false}
        autoPlay={false}
        swipeable={false}
        draggable={false}
        customButtonGroup={<ButtonGroup />}
        className={styles.carouselContainer}
      >
        {Reviews.map((reviewItem, index) => {
          return (
            // <Grid container spacing={2} className="d-flex align-items-center">
            //   <Grid key={index} item md={3} xl={3} lg={3} sm={12} xs={12}>
            <CarouselContentComponent reviewItem={reviewItem} />
            //   </Grid>
            // </Grid>
          );
        })}
      </Carousel>
    </div>
  );
};
export default CarouselComponent;
